// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mds-icon__cwp{fill:#5e5e5e;stroke:#5e5e5e;display:inline-block;height:23px;stroke-width:1.1;transition:.2s linear;width:23px}.mds-icon__cwp,.mds-icon__cwp *,.mds-icon__cwp:after,.mds-icon__cwp :after,.mds-icon__cwp:before,.mds-icon__cwp :before{box-sizing:border-box}.mds-icon__cwp svg{display:block}.mds-icon__cwp.mds-icon--small__cwp{height:15px;width:15px}", ""]);
// Exports
exports.locals = {
	"mds-icon": "mds-icon__cwp",
	"mds-icon--small": "mds-icon--small__cwp"
};
module.exports = exports;
